module.exports = __webpack_public_path__ + "static/media/point.2a378bb5.svg";